<template>
  <!-- 外层背景容器 宽度100% 底色#f2f5f9 -->
  <div class="module-card-wrap">
    <!-- 内层内容容器 宽度90% 居中 -->
    <div class="card-content">
      <div 
        class="card-item" 
        v-for="(item, index) in card_list" 
        :key="index"
        @mouseenter="handleHover(index)"
        @mouseleave="handleLeave(index)"
        :class="{active: hoverIndex === index}"
        role="group"
        :aria-label="`${item.h2} ${item.p}`"
      >
        <!-- 图标容器 -->
        <div class="icon-box">
          <img 
            :src="item.img" 
            alt="" 
            class="icon-img"
            loading="lazy"
            decoding="async"
            :alt="`${item.p}图标`"
          />
        </div>
        <!-- 数字/标题 -->
        <h2 class="card-title">{{ item.h2 }}</h2>
        <!-- 描述文字 -->
        <p class="card-desc">{{ item.p }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bg: String
  },
  data() {
    return {
      hoverIndex: -1,
      card_list: [
        {
          img: require('@/assets/icon11.png'),
          h2: '60+',
          p: '合作院校'
        },
        {
          img: require('@/assets/icon22.png'),
          h2: '20+',
          p: '产品知识产权'
        },
        {
          img: require('@/assets/icon33.png'),
          h2: '10,000+',
          p: '用户数'
        },
        {
          img: require('@/assets/icon55.png'),
          h2: '100+',
          p: '协同育人项目'
        }
      ]
    }
  },
  methods: {
    handleHover(index) {
      this.hoverIndex = index
    },
    handleLeave() {
      this.hoverIndex = -1
    }
  }
}
</script>

<style lang="scss" scoped>
// 外层背景容器
.module-card-wrap {
  width: 100%;
  background: #f2f5f9;
  padding: vw(80) 0;
  display: flex;
  justify-content: center;
  

  // 内层内容容器 90%宽度 居中
  .card-content {
    width: 90%;
    display: flex;
    gap: vw(32);
    align-items: stretch;
  }

  .card-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: vw(48) vw(24) vw(40);
    position: relative;
    overflow: hidden;
    // 卡片微渐变背景 + 细边框 + 柔和阴影
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border-radius: vw(24);
    border: 1px solid rgba(103, 166, 220, 0.1);
    box-shadow: 0 8px 24px rgba(103, 166, 220, 0.06);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    cursor: pointer;

    // 顶部渐变光条 默认隐藏
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(90deg, transparent, #67a6dc, transparent);
      opacity: 0;
      transition: opacity 0.4s ease;
    }

    // hover 激活状态
    &.active {
      transform: translateY(-vw(12));
      border-color: rgba(103, 166, 220, 0.3);
      box-shadow: 0 20px 40px rgba(103, 166, 220, 0.18);

      &::before {
        opacity: 1;
      }

      .icon-box {
        transform: scale(1.1) rotate(6deg);
        box-shadow: 0 8px 20px rgba(103, 166, 220, 0.3);
      }

      .card-title {
        // 数字渐变文字效果
        background: linear-gradient(135deg, #67a6dc 0%, #3d82c4 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }

    .icon-box {
      width: vw(104);
      height: vw(104);
      margin-bottom: vw(28);
      border-radius: 50%;
      background: linear-gradient(135deg, #e8f2fb 0%, #d6e8f7 100%);
      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      overflow: hidden;
      display: flex;
        justify-content: center;
        align-items: center;

      .icon-img {
        margin-top: 5px;
        width: 100%;
        height: 100%;
        object-fit: contain;
        // 删除原无效的display:flex代码
      }

      
      
    }
     &:nth-child(1) .icon-box .icon-img{
        margin-bottom: 15px;
    }

    &:nth-child(4) .icon-box .icon-img{
        margin-top: 10px;
    }

    .card-title {
      font-size: vw(40);
      font-weight: 800;
      color: #1a2b42;
      margin: 0 0 vw(12) 0;
      line-height: 1.2;
      transition: all 0.3s ease;
    }

    .card-desc {
      font-size: vw(18);
      line-height: 1.6;
      color: #5a6a85;
      margin: 0;
      font-weight: 500;
    }
  }

  // 移动端适配
  @media only screen and (max-width: 767px) {
    padding: vp(60) 0;

    .card-content {
      flex-direction: column;
      gap: vp(24);
    }

    .card-item {
      padding: vp(40) vp(24);
      border-radius: vp(16);

      &.active {
        transform: translateY(-vp(8));
      }

      .icon-box {
        width: vp(64);
        height: vp(64);
        margin-bottom: vp(20);
        .icon-img {
          width: 60%;
          height: 60%;
        }
      }

      .card-title {
        font-size: vp(32);
        margin-bottom: vp(10);
      }

      .card-desc {
        font-size: vp(16);
      }
    }
  }
}
</style>